import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Video {
  name: string;
  api_token: string;
}

export interface VideoListInfor {
  errors: unknown;
  video: Video;
  isAuthenticated: boolean;
}

@Module
export default class VideoModule extends VuexModule implements VideoListInfor {
  errors = {};
  video = {} as Video;
  isAuthenticated = !!JwtService.getToken();

  get Videos() {
    return this.videoListData;
  }

  @Mutation
  [Mutations.VIDEOS_LIST_DATA](Videos) {
    this.videoListData = Videos;
  }

  @Action
  [Actions.VIDEO_CREATE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("video/upsert", payload)
        .then((data) => {
          this.context.commit(Mutations.VIDEOS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.VIDEO_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("video", payload)
        .then((data) => {
          this.context.commit(Mutations.VIDEOS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.VIDEO_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/video", payload, "delete", payload)
        .then((data) => {
          this.context.commit(Mutations.VIDEOS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.VIDEO_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/video", "upsert", id, payload)
        .then((data) => {
          this.context.commit(Mutations.VIDEOS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
